import {
  BaseTextFieldProps,
  InputBaseProps,
  SxProps,
  TextField,
  Theme,
} from "@mui/material";
import { ReactNode } from "react";
import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label?: ReactNode;
  inputRef?: BaseTextFieldProps["inputRef"];
  sx?: SxProps<Theme>;
  required?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  minRows?: number;
  maxRows?: number;
  helperText?: string;
  disabled?: boolean;
  autoComplete?: "off";
  onFocus?: BaseTextFieldProps["onFocus"];
  size?: BaseTextFieldProps["size"];
  type?: BaseTextFieldProps["type"];
  inputProps?: BaseTextFieldProps["inputProps"];
  endAdornment?: InputBaseProps["endAdornment"];
}

export function ControlledTextField<T extends FieldValues>(props: Props<T>) {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={{
        ...(props.required && { required: "Required" }),
      }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          size={props.size}
          placeholder={props.placeholder}
          fullWidth={props.fullWidth}
          required={props.required}
          label={props.label}
          inputRef={props.inputRef}
          sx={props.sx}
          disabled={props.disabled}
          error={!!fieldState.error}
          helperText={props.helperText || fieldState.error?.message}
          multiline={props.multiline}
          onFocus={props.onFocus}
          rows={props.rows}
          minRows={props.minRows}
          maxRows={props.maxRows}
          type={props.type}
          {...(props.type === "number" && {
            onChange: (e) =>
              field.onChange(
                e.target.value === "" ? "" : Number(e.target.value)
              ),
          })}
          inputProps={props.inputProps}
          InputProps={{
            autoComplete: props.autoComplete,
            endAdornment: props.endAdornment,
          }}
        />
      )}
    />
  );
}
